export const INSTANCE_PATH = 'agents';

export enum AGENT_STATUS {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
}

export enum RESPONSE_ERROR {
    DUPLICATED_NAME = 'DUPLICATED_NAME',
}

export enum AGENT_MESSAGE_TYPE {
    TEXT = 'TEXT',
    FORWARD = 'FORWARD',
}

export enum AGENT_MESSAGE_CHAT_TYPE {
    SUPPORT = 'SUPPORT',
    FINANCE = 'FINANCE',
}

export const TELEGRAM_CHAT_ID_MAX_LENGTH = 100;
export const BALANCE_TELEGRAM_CHAT_ID_MAX_LENGTH = 100;
export const BALANCE_TELEGRAM_MESSAGE_ADDITION_MAX_LENGTH = 100;
